import { makeStyles } from '@mui/styles'

import { sharedGenericStyling } from './shared'
import { SPACING } from '@fedsim/constants'

export const useCardStyles = makeStyles(theme => {
  return {
    ...sharedGenericStyling,
    list: {
      ...sharedGenericStyling.list,
      overflow: 'unset',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'start',
      alignItems: 'center'
    },
    card: {
      // skin
      boxShadow: '5px 5px #999',
      backgroundColor: 'black',
      color: 'white',
      // structure
      alignSelf: 'stretch',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'space-between',
      // box
      margin: '0 8px 16px',
      padding: '.5rem',
      // width
      minHeight: 250, 
      // flexBasis: '350px',
      minWidth: 300,
      maxWidth: 500,
      '&:hover': {
          transform: 'scale(1.01)'
      }
    },
    actions: {
      // display: 'flex',
      // justifyContent: 'space-between',
      // alignItems: 'center',
      marginBottom: theme.spacing(SPACING),
    },
    selected: {
      margin: theme.spacing(0.6, 0)
    }
  }
})
